import { Icon, IconKind, IconSize } from "@saviynt/design-system";

export const iconMap: Record<string, IconKind> = {
  Machines: "MachineIdentity",
  Users: "User",
  Credentials: "Credentials",
  Entitlements: "Entitlement",
  Accounts: "Account",
};

export default function IconMap({
  source,
  size,
  className,
}: {
  source: string;
  size?: IconSize;
  className?: string;
}) {
  return (
    <Icon
      color="--color-foreground-primary-subtle"
      kind={iconMap[source]}
      size={size ?? "xSmall"}
      className={className}
    />
  );
}
